/*
 * @Author: 林逸飞
 * @Date: 2024-10-10 11:08:22
 * @LastEditors: 林逸飞
 * @LastEditTime: 2024-10-17 15:38:07
 * @FilePath: \pbiot-eam-webd:\lyf\code\demo\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/index.vue"),
  },
  {
    path: "/purchase",
    name: "purchase",
    component: () => import("../views/purchase.vue"),
  },
  {
    path: "/risk",
    name: "risk",
    component: () => import("../views/risk.vue"),
  },
  {
    path: "/dispatch",
    name: "dispatch",
    component: () => import("../views/dispatch.vue"),
  },
  {
    path: "/share",
    name: "purchase",
    component: () => import("../views/share.vue"),
  },
  {
    path: "/supervise",
    name: "supervise",
    component: () => import("../views/supervise.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
